import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import {
  useRecoilState,
  useSetRecoilState
} from 'recoil';
import { useTranslation } from 'react-i18next';
import {
  Drawer,
  Avatar,
  Tooltip,
  InputNumber,
  Row,
  Col,
  Button,
  Select,
  Input,
  notification
} from 'antd';
import { Comment } from '@ant-design/compatible';
import moment from 'moment';
import Grocefy from '../../../../assets/images/grocefyLogoAlone.png';
import {
  selectedDeliveryProviderAtom,
  refreshDeliveryProviderAtom,
  manageDeliveryProviderUsersAtom,
  manageDeliveryProviderZonesAtom
} from '../../../../atoms/Atoms';
import api from '../../../../api/api';

function EditDeliveryProvider() {
  const { Option } = Select;
  const setRefreshProviders = useSetRecoilState(refreshDeliveryProviderAtom);
  const [manageProviderUsers, setManageProviderUsers] =
  useRecoilState(manageDeliveryProviderUsersAtom);
  const [manageProviderZones, setManageProviderZones] =
  useRecoilState(manageDeliveryProviderZonesAtom);
  const [selectedProvider, setSelectedProvider] = useRecoilState(selectedDeliveryProviderAtom);
  const [loading, setLoading] = useState(false);
  const [provider, setProvider] = useState({});
  const { t } = useTranslation();

  const showMessage = function (message) {
    notification.open({
      message: '',
      description: (
        <Comment
          author={<span>Grocefy</span>}
          avatar={<Avatar src={Grocefy} alt="grocefy" />}
          content={
            <p className="text-sm">
              {message}
            </p>
          }
          datetime={
            <Tooltip title={moment().format('YYYY-MM-DD HH:mm:ss')}>
              <span>{moment().fromNow()}</span>
            </Tooltip>
          }
        />
      ),
    });
  };

  const submit = function () {
    setLoading(true);
    const temp = JSON.parse(JSON.stringify(provider));
    api.post(
      'tpd/providers',
      temp
    )
      .then((response) => {
        setLoading(false);
        if (response.data.success) {
          setRefreshProviders(true);
          setSelectedProvider(null);
        } else {
          showMessage(response.data.error);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  };

  const archiveClick = function () {
    setLoading(true);
    api.delete(
      `tpd/providers/${provider.id}`,
      { }
    )
      .then((response) => {
        setLoading(false);
        if (response.data.success) {
          setSelectedProvider(null);
          setRefreshProviders(true);
        } else {
          console.error(response.data.error);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  };

  useEffect(() => {
    if (selectedProvider) {
      const temp = JSON.parse(JSON.stringify(selectedProvider));
      if (!temp.id) {
        temp.rate = 0;
        temp.rateType = 0;
        temp.deliverFeeRate = 0;
        temp.deliveryFeeRateType = 0;
      }
      setProvider(temp);
    }
  }, [selectedProvider]);

  return (
    <Drawer
      title={`${provider && provider.id ? t('update') : t('create')} ${t('delivery_provider')}`}
      placement="right"
      closable
      onClose={() => setSelectedProvider(null)}
      open={selectedProvider && !manageProviderUsers && !manageProviderZones}
      width={400}
    >
      {selectedProvider && (
        <>
          <div
            style={{
              float: 'right',
              marginBottom: '10px'
            }}
          >
            <Button
              type="primary"
              danger
              disabled={loading}
              hidden={!provider.id}
              onClick={() => { archiveClick(); }}
            >
              {t('archive')}
            </Button>
          </div>
          <br />
          <div style={{ marginBottom: 10 }}>
            <strong>{t('name')}:</strong>
            <Input
              disabled={loading}
              placeholder="Name"
              onChange={(obj) => {
                const temp = JSON.parse(JSON.stringify(provider));
                temp.name = obj.target.value;
                setProvider(temp);
              }}
              value={provider.name}
            />
          </div>
          <div style={{ marginBottom: 10 }}>
            <strong>{t('rate_type')}: </strong>
            <br />
            <Select
              defaultValue={provider.rateType}
              value={provider.rateType}
              style={{ width: 120 }}
              disabled={loading}
              onChange={(obj) => {
                const temp = JSON.parse(JSON.stringify(provider));
                temp.rateType = obj;
                setProvider(temp);
              }}
            >
              <Option value={0}>{t('none')}</Option>
              <Option value={1}>{t('fixed')}</Option>
              <Option value={2}>{t('percentage')}</Option>
            </Select>
          </div>
          <div style={{ marginBottom: 10 }}>
            <strong>{t('rate')}</strong>
            <br />
            <InputNumber
              disabled={loading}
              min={0}
              onChange={(obj) => {
                const temp = JSON.parse(JSON.stringify(provider));
                temp.rate = obj;
                setProvider(temp);
              }}
              value={provider.rate}
            />
          </div>
          <div style={{ marginBottom: 10 }}>
            <strong>{t('delivery_rate_type')}: </strong>
            <br />
            <Select
              defaultValue={provider.deliveryFeeRateType}
              value={provider.deliveryFeeRateType}
              style={{ width: 120 }}
              disabled={loading}
              onChange={(obj) => {
                const temp = JSON.parse(JSON.stringify(provider));
                temp.deliveryFeeRateType = obj;
                setProvider(temp);
              }}
            >
              <Option value={0}>{t('none')}</Option>
              <Option value={1}>{t('fixed')}</Option>
              <Option value={2}>{t('percentage')}</Option>
            </Select>
          </div>
          <div style={{ marginBottom: 10 }}>
            <strong>{t('delivery_rate')}</strong>
            <br />
            <InputNumber
              disabled={loading}
              min={0}
              onChange={(obj) => {
                const temp = JSON.parse(JSON.stringify(provider));
                temp.deliveryFeeRate = obj;
                setProvider(temp);
              }}
              value={provider.deliveryFeeRate}
            />
          </div>
          {selectedProvider?.id && (
            <Row>
              <Col span={12}>
                <Button
                  className="mr-1 w-full"
                  type="primary"
                  disabled={loading}
                  onClick={() => setManageProviderUsers(true)}
                >
                  {t('users')}
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  className="ml-1 w-full"
                  type="primary"
                  disabled={loading}
                  onClick={() => setManageProviderZones(true)}
                >
                  {t('delivery_zones')}
                </Button>
              </Col>
            </Row>
          )}
          <div
            style={{
              float: 'right',
              marginTop: '10px'
            }}
          >
            <Button
              style={{
                marginLeft: '10px'
              }}
              disabled={loading ||
                !(provider?.name?.length > 0)}
              loading={loading}
              type="primary"
              onClick={() => { submit(); }}
            >
              {provider.id ? 'Update' : 'Create'}
            </Button>
          </div>
        </>
      )}
    </Drawer>
  );
}

export default EditDeliveryProvider;
